import React, { Component } from 'react';
import {
  element, arrayOf, oneOfType, number, func, string, shape
} from 'prop-types';
import { Translate } from 'react-localize-redux';
import styles from './foldableList.module.css';

const DEFAULT_FOLD_THRESHOLD = 10;

class FoldableList extends Component {
  constructor(props) {
    super(props);

    this.handleFoldButtonClick = this.handleFoldButtonClick.bind(this);
    this.renderElements = this.renderElements.bind(this);
    this.renderFoldButton = this.renderFoldButton.bind(this);

    const foldThreshold = props.foldThreshold > 0 ? props.foldThreshold : DEFAULT_FOLD_THRESHOLD;

    this.state = {
      foldList: true,
      foldThreshold
    };
  }

  handleFoldButtonClick(event) {
    event.preventDefault();
    this.setState((prevState) => ({ foldList: !prevState.foldList }));
  }

  renderElements() {
    if (this.props.children && this.props.children.length) {
      const elements = this.state.foldList
        ? this.props.children.slice(0, this.state.foldThreshold)
        : this.props.children;
      return (
        this.props.renderFunction(elements)
      );
    }

    return (
      <p className={styles.noElements}>
        {this.props.noElementsMessage
          ? this.props.noElementsMessage : null}
      </p>
    );
  }

  renderFoldButton() {
    if (this.props.children.length > this.state.foldThreshold) {
      return (
        <button type="button" className={styles.expandButton} onClick={this.handleFoldButtonClick}>
          <Translate id={
          this.state.foldList
            ? 'common.showAll' : 'common.showLess'
}
          />
        </button>
      );
    }
    return null;
  }

  render() {
    return (
      <div className={styles.foldableList}>
        {this.props.heading}
        {this.renderElements()}
        {this.renderFoldButton()}
      </div>
    );
  }
}

FoldableList.defaultProps = {
  foldThreshold: DEFAULT_FOLD_THRESHOLD,
  heading: null,
  noElementsMessage: null,
  renderFunction: (elements) => (
    <ul className={styles.listEntries}>{
    elements.map(
    // eslint-disable-next-line react/no-array-index-key
      (e, idx) => (<li key={idx} className={styles.item}>{e}</li>)
    )
}
    </ul>
  )
};

FoldableList.propTypes = {
  foldThreshold: number,
  heading: oneOfType([element, string]),
  children: arrayOf(oneOfType([element, string, number, shape()])).isRequired,
  noElementsMessage: oneOfType([element, string]),
  renderFunction: func
};

export default FoldableList;
